import type { WorkspaceState } from '../types/workspace';
import { createLegacyCompiler, PLATFORM_TEMPLATES } from './legacyCompiler';
import type { Asset, CompilerInput, LegacyPrompt, ShaperPlan, Template } from './legacyCompiler';

export type PromptRecord = LegacyPrompt & { slotId:string };
export type PreparedPlan = { workspace:WorkspaceState; input:CompilerInput; template:Template; plan:ShaperPlan; prompts:PromptRecord[]; warning?:string };

// Asset copy language follows the target market, independently of the UI locale.
export function compilerContext(workspace:WorkspaceState, productImages:Asset[], referenceImages:Asset[] = []) {
  const slots = workspace.plan.filter(slot => slot.enabled);
  if (!slots.length || slots.length > 10) throw new Error('Choose between 1 and 10 images.');
  if (!workspace.productName.trim() || !productImages.length) throw new Error('Add a product name and photo.');
  const platform = workspace.platform.id;
  const template:Template = PLATFORM_TEMPLATES[platform] || {
    name:workspace.platform.name, imageCount:slots.length, minImageCount:1, maxImageCount:10,
    aspectRatio:'1:1', tone:'Accurate, informative, uncluttered product photography.',
    imagePurposes:slots.map(slot => slot.purpose), slotRules:slots.map(slot => slot.platformRule || 'Keep the product unmistakably visible and accurate.'), constraints:[]
  };
  const input:CompilerInput = {
    platform, market:({jp:'japan',tw:'taiwan',cn:'china',hk:'hongkong'} as const)[workspace.market.id],
    locale:({jp:'ja-JP',tw:'zh-TW',cn:'zh-CN',hk:'zh-HK'} as const)[workspace.market.id],
    instructionLanguage:'en',copyItems:[],imageCount:slots.length,imageCountTouched:true,
    category:workspace.category || 'electronics',productName:workspace.productName,
    productVariant:workspace.productVariant || '',categoryFacts:workspace.categoryFacts || '',categoryPreference:'',
    batchDirection:workspace.creativeDirection,season:'',promotion:'',constraints:{},
    productImages,referenceImages:referenceImages || [],shaperPlan:null
  };
  return {input,template,engine:createLegacyCompiler(input,template)};
}

export function compilePromptRecords(workspace:WorkspaceState, input:CompilerInput, template:Template, plan:ShaperPlan):PromptRecord[] {
  const engine = createLegacyCompiler({...input,shaperPlan:plan},template);
  return workspace.plan.filter(slot => slot.enabled).map((slot,index) => {
    const record = engine.buildPromptRecord(index);
    const protections = Object.entries(slot.preserve).filter(([,enabled]) => enabled).map(([key]) => key).join(', ');
    return {...record,slotId:slot.id,prompt:[record.prompt,
      `OPERATOR SLOT DIRECTION\nPurpose: ${slot.purpose}\nDirection: ${slot.direction}\nNote: ${slot.note || 'none'}\nExplicit preservation priorities: ${protections || 'product identity'}. These preferences do not relax product truth, platform rules, or copy restrictions.`
    ].join('\n\n')};
  });
}
